import loadableWithRetry from '../common/loadableWithRetry'

const WishList = loadableWithRetry(() => import('./WishList'))

//import WishList from './WishList';

export default WishList;
